import React from "react";

import BreakdownInfoTableRow from "shared/components/Breakdown/BreakdownInfoTable/BreakdownInfoTableRow/BreakdownInfoTableRow";

import "./BreakdownInfoTable.scss";

class BreakdownInfoTable extends React.PureComponent<
  React.PropsWithChildren<{}>
> {
  public static Row = BreakdownInfoTableRow;

  public render() {
    return <div className="c-breakdown-info-table">{this.props.children}</div>;
  }
}

export default BreakdownInfoTable;
